export default "__VITE_ASSET__BCd3btjv__"